'use strict';

angular.module('cgmemApp')
	.factory('AppConfig', ['$http', '$log', '$q', function ($http, $log, $q) {
		var offset = 0;
		var p = null;
		var api = {};
		var appConfig = {};

		api.load = function () {
			p = $http.get('/api/clientconfig')
				.then(function (response) {
					var a = _.reduce(response.data.clientConfig, function (acc, item) {
						acc[item._id] = item.val;
						return acc;
					}, {});
					offset = (new Date()).getTime() - response.data.epoch;
					angular.copy(a, appConfig);
					//$log.log('PC clock offset: (ms):', offset);
					return appConfig;
				})
				.catch(function (httpError) {
					$q.reject(httpError.status + " : " + httpError.data);
				});
		}


		api.get = function () {
			return p;
		}

		// How many ms we are ahead of server time
		api.getOffset = function () {
			return offset;
		}

		// trigger initial load
		api.load();

		return api;
	}]);
